import './App.css';
//rrd
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

//importing components
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import NoteState from './context/notes/NoteState';
import Alert from './components/Alert';
import Login from './components/Login';
import Signup from './components/Signup';
import { useState } from 'react';
import Chats from './components/Chats';


function App() {
  const [alert, setalert] = useState(null);

  const showAlert=(message,type)=>{
    setalert({
      msg:message,
      type:type
    })
    setTimeout(() => {
      setalert(null)
    }, 2000);
  }

  return (
    <>
      <NoteState >
        <Router>
          <Navbar showAlert={showAlert}/>
          <Alert alert={alert}/>
          <div >
            <Routes>
              <Route exact path="/" element={<Home showAlert={showAlert}/>} />
              <Route exact path="/about" element={<About />} />
              <Route exact path="/login" element={<Login showAlert={showAlert}/>} />
              <Route exact path="/signup" element={<Signup showAlert={showAlert}/>} />
              <Route exact path="/chats" element={<Chats />} />
            </Routes>
          </div>
        </Router>
      </NoteState>
    </>
  );
}

export default App;
